import React from 'react';
import PropTypes from 'prop-types';
import { Loader as Loading } from 'react-loaders';
import './Loader.css';

export function Loader (props) {
  return props.error !== null 
  ? (
    <div id="loader-wrapper">{props.error}</div>
  )
  : (
    <div id="loader-wrapper">
      <Loading type="ball-spin-fade-loader" active={props.loading} />
    </div>
  );
}


// WEBPACK FOOTER //
// ./src/components/Loader/Loader.js